import Img1 from '../../images/svg-1.svg'
import Img2 from '../../images/svg-2.svg'
import Img3 from '../../images/svg-3.svg'

export const homeObjOne = {
    id: 'about',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Premium Bank',
    headline: 'Unlimited Transactions with zero fess',
    description: 'Get access to our exclusive app that allows you to send unlimited transactions without getting charged any fees',
    buttonLabel: 'Get Started',
    imgStart: true,
    img: Img1,
    alt: 'Car',
    dark: false,
    primary: true,
    darkText: true
}
export const homeObjTwo = {
    id: 'discover',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Unlimited Access',
    headline: 'Login to your account at any time',
    description: 'We have your covered no matter where you are. All you need is an internet connection and a smart device',
    buttonLabel: 'Learn More',
    imgStart: false,
    img: Img2,
    alt: 'Car',
    dark: false,
    primary: true,
    darkText: true
}
export const homeObjThree = {
    id: 'signup',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Join Our Team',
    headline: 'Creating an account is extremely easy',
    description: 'Get everything setup and ready in under 10 minutes. All you need to do is add your information and you are ready to go.',
    buttonLabel: 'Start Now',
    imgStart: true,
    img: Img3,
    alt: 'Car',
    dark: false,
    primary: false,
    darkText: true
}